import {getRandNum,intRandom} from './_randNum';

export function logo() {
  const logo = document.querySelectorAll('.js-logo');
  if(logo.length) {
    const logoInit = () => {
      for (let i = 0; i < logo.length; i++) {
        const el = logo[i];
        const path = el.querySelectorAll('path');
        /** 重複チェック用配列 */
        let randoms = [];
        /** 最小値と最大値 */
        const min = 0;
        const max = path.length;
        /** 重複チェックしながら乱数作成 */
        for(let i = min; i <= max; i++){
          while(true){
            var tmp = intRandom(min, max);
            if(!randoms.includes(tmp)){
              randoms.push(tmp);
              break;
            }
          }
        }
        if(el.classList.contains('is-no-fadein')) {
          if(path) {
            for (let i = 0; i < path.length; i++) {
              const _el = path[i];
              setTimeout(() => {
                _el.style.animationDelay = `0ms`;
                _el.style.animationDuration = `${intRandom(5000, 10000)}ms`;
                if(el.classList.contains('logo-short')) {
                  _el.style.animationName = `logo-path-scale-infinite-short`;
                } else {
                  _el.style.animationName = `logo-path-scale-infinite`;
                }
                _el.style.animationFillMode = `none`;
                _el.style.animationDirection = `alternate`;
                _el.style.animationIterationCount = `infinite`;
                _el.style.animationTimingFunction = `linear`;
                _el.style.opacity = '1';
              }, intRandom(100, 6000));
            }
          }
        } else {
          if(path) {
            for (let i = 0; i < path.length; i++) {
              const _el = path[i];
              const delay = getRandNum(4000);
              const done = delay+4000
              setTimeout(() => {
                _el.style.animationDelay = `${delay}ms`;
                _el.style.animationDuration = `4000ms`;
                _el.style.animationName = `logo-path-scale`;
                _el.style.animationFillMode = `forwards`;
                setTimeout(() => {
                  _el.style.animationDelay = `0ms`;
                  _el.style.animationDuration = `${intRandom(5000, 10000)}ms`;
                  if(el.classList.contains('logo-short')) {
                    _el.style.animationName = `logo-path-scale-infinite-short`;
                  } else {
                    _el.style.animationName = `logo-path-scale-infinite`;
                  }
                  _el.style.animationFillMode = `none`;
                  _el.style.animationDirection = `alternate`;
                  _el.style.animationIterationCount = `infinite`;
                  _el.style.animationTimingFunction = `linear`;
                }, done);
              }, 100);
            }
          }
        }
      }
    }
    logoInit();
  }
}